'use strict'

let watermark = {}
const waterid = 'waterid';
let setWatermark = (str) => {
    let id = waterid;

    if (document.getElementById(id) !== null) {
        document.body.removeChild(document.getElementById(id))
    }
    let clientWidth = document.documentElement.clientWidth;
    let can = document.createElement('canvas')
    can.width = clientWidth/3.5//30*str.length
    can.height = Math.tan(Math.PI/8)*can.width

    let cans = can.getContext('2d')
    cans.rotate(-20 * Math.PI / 180)
    cans.font = 'normal 500 20px Vedana'
    cans.fillStyle = 'rgba(180, 180, 180, 0.40)'
    cans.textAlign = 'left'
    cans.textBaseline = 'Middle'
    cans.fillText(str,0, can.height)

    let div = document.createElement('div')
    div.id = id
    div.style.pointerEvents = 'none'
    div.style.top = '0px'
    div.style.left = '-40px'
    div.style.position = 'fixed'
    div.style.zIndex = '1000'
    // div.style.width = document.documentElement.clientWidth - 100 + 'px'
    div.style.width = document.documentElement.clientWidth+80 + 'px'
    div.style.height = document.documentElement.clientHeight+ 'px'
    div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
    document.body.appendChild(div)
    return id
}

// 该方法只允许调用一次
watermark.set = (str) => {
    if (document.getElementById(waterid) === null) {
        setWatermark(str)
    }
}
watermark.remove = () => {
    var elem = document.getElementById(waterid);
    if (elem !== null){
        document.body.removeChild(elem)
    }
};
export default watermark
